module.exports = __webpack_public_path__ + "static/media/triangle_down.8c7a932f.png";